<template>
  <span>
    <span
      style="font-size: smaller;"
      class="text-nowrap px-1"
    >
      {{ data }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'MakeSmallTextCell',
  props: {
    data: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>
